"use client";

import IconifyIcon from "@/components/wrappers/IconifyIcon";
import SimplebarReactClient from "@/components/wrappers/SimplebarReactClient";
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from "react-bootstrap";
import { timeSince } from "@/utils/date";
import Link from "next/link";
import { fetchWrapper } from "@/helpers/fetch-wrapper";
import { toast } from 'react-toastify'; 
import { useState, useEffect } from "react";

const Notifications = (props) => {
	const { notifications: initialNotifications = [], notificationsCount } = props;
	const [notifications, setNotifications] = useState(initialNotifications);

	// Sincronizează state-ul când props-urile se schimbă
	useEffect(() => {
		setNotifications(initialNotifications);
	}, [initialNotifications]);

	const markAsRead = async (id) => {
		try {
			await fetchWrapper.post(`/api/users/notifications`, { id });
			
			// Elimină notificarea din listă
			setNotifications((prev) => prev.filter((notification) => notification.id !== id));
			
			toast.success("Notificare marcată ca citită!");
		} catch (error) {
			console.error("Error marking notification as read:", error);
			toast.error("Eroare la marcarea notificării!");
		}
	};

	const hasNotifications = notifications && notifications.length > 0;

	return (
		<div className='topbar-item'>
			<Dropdown align={"end"}>
				<DropdownToggle
					as={"a"}
					className='topbar-link drop-arrow-none'
					data-bs-toggle='dropdown'
					data-bs-offset='0,25'
					data-bs-auto-close='outside'
					aria-haspopup='false'
					aria-expanded='false'>
					<IconifyIcon
						icon='ri:notification-snooze-line'
						className={hasNotifications ? "animate-ring fs-22" : "fs-22"}
					/>
					{hasNotifications && <span className='noti-icon-badge' />}
				</DropdownToggle>
				<DropdownMenu
					className='p-0 dropdown-menu-start dropdown-menu-lg'
					style={{
						minHeight: 300,
					}}>
					<div className='p-3 border-bottom border-dashed'>
						<Row className='align-items-center'>
							<Col>
								<h6 className='m-0 fs-16 fw-semibold'> Notificari necitite</h6>
							</Col>
						</Row>
					</div>

					{hasNotifications ? (
						<SimplebarReactClient
							className='position-relative z-2 card shadow-none rounded-0'
							style={{
								maxHeight: 300,
							}}>
							{notifications.map((item, idx) => (
								<div
									className='notification-item dropdown-item py-2 text-wrap'
									id={`notification-${item.id}`}
									key={item.id || idx}>
									<span className='d-flex align-items-center'>
										<div className='avatar-md flex-shrink-0 me-3'>
											<span className='avatar-title bg-primary-subtle text-primary rounded-circle fs-22'>
												<IconifyIcon icon='ri:notification-line' />
											</span>
										</div>

										<span className='flex-grow-1 text-muted'>
											{item.message?.length <= 53 ? item.message : `${item.message?.substring(0, 50)}...`}
											<br />
											<span className='fs-12'>
												{timeSince(item.createdAt || item.time)} de la <b>{item.byName}</b>
											</span>
										</span>
										<span
											className='notification-item-close'
											onClick={() => markAsRead(item.id)}>
											<button
												type='button'
												className='btn btn-ghost-success rounded-circle btn-sm btn-icon'
												data-dismissible={`#notification-${item.id}`}
												title='Marchează ca citită'>
												<IconifyIcon icon='tabler:check' className='fs-16' />
											</button>
										</span>
									</span>
								</div>
							))}
						</SimplebarReactClient>
					) : (
						<div
							style={{
								height: 300,
							}}
							className='d-flex align-items-center justify-content-center text-center'>
							<div>
								<IconifyIcon
									icon='line-md:bell-twotone-alert-loop'
									className='fs-80 text-secondary mt-2'
								/>
								<h4 className='fw-semibold mb-0 fst-italic lh-base mt-3'>
									Hey! 👋 <br />
									Nu ai nicio notificare necitita.
								</h4>
							</div>
						</div>
					)}

					<Link
						href=''
						className='dropdown-item notification-item text-center text-reset text-decoration-underline link-offset-2 fw-bold notify-item border-top border-light py-2'>
						Vezi toate notificarile
					</Link>
				</DropdownMenu>
			</Dropdown>
		</div>
	);
};
export default Notifications;